import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from '@elem/ui/ef-img';
import { useState } from 'react';
import gtm from '@/utils/gtm';

interface ItemType {
    title: string;
    desc: string;
    img: [string, string];
}
export default function O() {
    const { t } = useLang('bkw');
    const [active, setActive] = useState(0);
    const items: ItemType[] = [
        {
            title: t('O_item1_title'),
            desc: t('O_item1_desc'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1738919460237/15_1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1738920552083/15_1_M.jpg'],
        },
        {
            title: t('O_item2_title'),
            desc: t('O_item2_desc'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1738919461179/15_2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1738919460978/15_2_M.jpg'],
        },
        {
            title: t('O_item3_title'),
            desc: t('O_item3_desc'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1738919460603/15_3.jpg', 'https://websiteoss.ecoflow.com/upload/image/1738920529062/15_3_M.jpg'],
        },
    ];

    const handleCollapse = (item: ItemType, k: number) => {
        setActive(k);
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_button',
            page_name: t('A_label'),
            list_name: 'Entdecken Sie Tadellose Energiekontrolle Ihres Haushalts mit Smart Plugs und der EcoFlow App',
            button_name: item.title,
            function: 'Expand Content',
        });
    };

    return (
        <div id="bkw-O" className={`bkw-O bkw-box ${css['bkw-O']}`}>
            <EfSpec />
            <div className="info">
                <h2 className="title">
                    {t.rich('O_title', {
                        y: (tx: string) => <span className="y">{tx}</span>,
                    })}
                </h2>
                <p className="desc">{t('O_desc')}</p>
            </div>
            <div className="wrapper">
                <ul className="items">
                    {items.map((item: ItemType, k: number) => (
                        <li className={`item${k === active ? ' active' : ''}`} key={k} onClick={() => handleCollapse(item, k)}>
                            <p className="item-title">{item.title}</p>
                            <div className="item-desc">
                                <p>{item.desc}</p>
                            </div>
                            {active !== k && (
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
                                    <path
                                        d="M12.6845 23.0857C18.3243 23.0857 22.8963 18.5138 22.8963 12.8739C22.8963 7.2341 18.3243 2.66211 12.6845 2.66211C7.04464 2.66211 2.47266 7.2341 2.47266 12.8739C2.47266 18.5138 7.04464 23.0857 12.6845 23.0857Z"
                                        stroke="#757575"
                                        stroke-width="1.53177"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M8.59961 11.8535L12.6843 15.9382L16.7691 11.8535"
                                        stroke="#757575"
                                        stroke-width="1.53177"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            )}
                        </li>
                    ))}
                </ul>
                <div className="img-box">
                    <EfImg pc={items[active].img[0]} />
                </div>
            </div>
        </div>
    );
}
